import React from 'react';
import styled from 'styled-components';

interface Props {
  isCopied: boolean;
  display: boolean;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
}

export const CopyBlock: React.FC<Props> = (props) => {
  return (
    <Container display={props.display} onClick={props.onClick}>
      <p>{props.isCopied ? 'Copied!' : 'Copy'}</p>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_619_306734" maskUnits="userSpaceOnUse" x="4" y="1" width="14" height="16">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M18 1H4V4H15V17H18V1Z" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_619_306734)">
          <mask id="path-2-inside-1_619_306734" fill="white">
            <rect x="5" y="2" width="12" height="14" rx="1" />
          </mask>
          <rect
            x="5"
            y="2"
            width="12"
            height="14"
            rx="1"
            stroke="white"
            strokeWidth="2.4"
            mask="url(#path-2-inside-1_619_306734)"
          />
        </g>
        <mask id="path-3-inside-2_619_306734" fill="white">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3 5C2.44772 5 2 5.44772 2 6V18C2 18.5523 2.44772 19 3 19H13C13.5523 19 14 18.5523 14 18V6C14 5.44772 13.5523 5 13 5H3ZM4.9998 8.30005C4.61321 8.30005 4.2998 8.61345 4.2998 9.00005C4.2998 9.38665 4.61321 9.70005 4.9998 9.70005L10.9998 9.70005C11.3864 9.70005 11.6998 9.38665 11.6998 9.00005C11.6998 8.61345 11.3864 8.30005 10.9998 8.30005H4.9998ZM4.9998 11.3C4.61321 11.3 4.2998 11.6135 4.2998 12C4.2998 12.3866 4.61321 12.7 4.9998 12.7L10.9998 12.7C11.3864 12.7 11.6998 12.3866 11.6998 12C11.6998 11.6135 11.3864 11.3 10.9998 11.3L4.9998 11.3ZM4.2998 15C4.2998 14.6135 4.61321 14.3 4.9998 14.3H10.9998C11.3864 14.3 11.6998 14.6134 11.6998 15C11.6998 15.3866 11.3864 15.7 10.9998 15.7L4.9998 15.7C4.61321 15.7 4.2998 15.3866 4.2998 15Z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3 5C2.44772 5 2 5.44772 2 6V18C2 18.5523 2.44772 19 3 19H13C13.5523 19 14 18.5523 14 18V6C14 5.44772 13.5523 5 13 5H3ZM4.9998 8.30005C4.61321 8.30005 4.2998 8.61345 4.2998 9.00005C4.2998 9.38665 4.61321 9.70005 4.9998 9.70005L10.9998 9.70005C11.3864 9.70005 11.6998 9.38665 11.6998 9.00005C11.6998 8.61345 11.3864 8.30005 10.9998 8.30005H4.9998ZM4.9998 11.3C4.61321 11.3 4.2998 11.6135 4.2998 12C4.2998 12.3866 4.61321 12.7 4.9998 12.7L10.9998 12.7C11.3864 12.7 11.6998 12.3866 11.6998 12C11.6998 11.6135 11.3864 11.3 10.9998 11.3L4.9998 11.3ZM4.2998 15C4.2998 14.6135 4.61321 14.3 4.9998 14.3H10.9998C11.3864 14.3 11.6998 14.6134 11.6998 15C11.6998 15.3866 11.3864 15.7 10.9998 15.7L4.9998 15.7C4.61321 15.7 4.2998 15.3866 4.2998 15Z"
          fill="white"
        />
        <path
          d="M4.9998 9.70005V10.9V10.9V9.70005ZM10.9998 9.70005V8.50005V9.70005ZM4.9998 11.3V12.5V12.5V11.3ZM4.9998 12.7V13.9V12.7ZM10.9998 12.7V11.5V11.5V12.7ZM10.9998 11.3V10.1V10.1V11.3ZM10.9998 15.7V14.5V15.7ZM4.9998 15.7V16.9H4.9998L4.9998 15.7ZM3.2 6C3.2 6.11046 3.11046 6.2 3 6.2V3.8C1.78497 3.8 0.8 4.78497 0.8 6H3.2ZM3.2 18V6H0.8V18H3.2ZM3 17.8C3.11046 17.8 3.2 17.8895 3.2 18H0.8C0.8 19.215 1.78497 20.2 3 20.2V17.8ZM13 17.8H3V20.2H13V17.8ZM12.8 18C12.8 17.8895 12.8895 17.8 13 17.8V20.2C14.215 20.2 15.2 19.215 15.2 18H12.8ZM12.8 6V18H15.2V6H12.8ZM13 6.2C12.8895 6.2 12.8 6.11046 12.8 6H15.2C15.2 4.78497 14.215 3.8 13 3.8V6.2ZM3 6.2H13V3.8H3V6.2ZM5.4998 9.00005C5.4998 9.27619 5.27595 9.50005 4.9998 9.50005V7.10005C3.95046 7.10005 3.0998 7.95071 3.0998 9.00005H5.4998ZM4.9998 8.50005C5.27595 8.50005 5.4998 8.72391 5.4998 9.00005H3.0998C3.0998 10.0494 3.95046 10.9 4.9998 10.9V8.50005ZM10.9998 8.50005L4.9998 8.50005V10.9L10.9998 10.9V8.50005ZM10.4998 9.00005C10.4998 8.72391 10.7237 8.50005 10.9998 8.50005V10.9C12.0491 10.9 12.8998 10.0494 12.8998 9.00005H10.4998ZM10.9998 9.50005C10.7237 9.50005 10.4998 9.27619 10.4998 9.00005H12.8998C12.8998 7.95071 12.0491 7.10005 10.9998 7.10005V9.50005ZM4.9998 9.50005H10.9998V7.10005H4.9998V9.50005ZM5.4998 12C5.4998 12.2762 5.27595 12.5 4.9998 12.5V10.1C3.95046 10.1 3.0998 10.9507 3.0998 12H5.4998ZM4.9998 11.5C5.27595 11.5 5.4998 11.7239 5.4998 12H3.0998C3.0998 13.0494 3.95046 13.9 4.9998 13.9V11.5ZM10.9998 11.5L4.9998 11.5V13.9H10.9998V11.5ZM10.4998 12C10.4998 11.7239 10.7237 11.5 10.9998 11.5V13.9C12.0491 13.9 12.8998 13.0494 12.8998 12H10.4998ZM10.9998 12.5C10.7237 12.5 10.4998 12.2762 10.4998 12H12.8998C12.8998 10.9507 12.0491 10.1 10.9998 10.1V12.5ZM4.9998 12.5L10.9998 12.5V10.1L4.9998 10.1V12.5ZM4.9998 13.1C3.95046 13.1 3.0998 13.9507 3.0998 15H5.4998C5.4998 15.2762 5.27595 15.5 4.9998 15.5V13.1ZM10.9998 13.1H4.9998V15.5H10.9998V13.1ZM12.8998 15C12.8998 13.9507 12.0491 13.1 10.9998 13.1V15.5C10.7237 15.5 10.4998 15.2762 10.4998 15H12.8998ZM10.9998 16.9C12.0491 16.9 12.8998 16.0494 12.8998 15H10.4998C10.4998 14.7239 10.7237 14.5 10.9998 14.5V16.9ZM4.9998 16.9L10.9998 16.9V14.5L4.9998 14.5L4.9998 16.9ZM3.0998 15C3.0998 16.0494 3.95046 16.9 4.9998 16.9V14.5C5.27595 14.5 5.4998 14.7239 5.4998 15H3.0998Z"
          fill="white"
          mask="url(#path-3-inside-2_619_306734)"
        />
      </svg>
    </Container>
  );
};

const Container = styled.div<{ display: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;

  ${(props) =>
    !props.display &&
    `
    opacity: 0;
    pointer-events: none;
  `}

  &:hover {
    opacity: 0.8;
  }

  p {
    margin-bottom: 0 !important;
    color: #fff !important;
    font-size: 0.75rem;
    line-height: 1rem;
  }

  svg {
    position: relative !important;

    #mask0_619_306734 {
      mask-type: alpha;
    }
  }
`;
